<template>
    <div class="calculator lz" :class="{[settings?.type] : settings?.type, mini : mini, [template] : template}">

        <div class="mini" :class="{collapsed: miniCollapsed}" v-if="mini">
            <div class="line">
                <div class="item">{{settings?.local?.youGet}}</div>
                <div class="value">{{calculatorValue?.toLocaleString()}} {{settings?.currency}}</div>
            </div>
            <vue-slider v-if="!miniCollapsed"
                        v-model="calculatorValue"
                        v-bind="options"
                        @change="handeDrag"
                        @dragging="handeDrag"
            />
            <div class="line highlight">
                <div class="item">{{settings?.local?.toBack}}</div>
                <div class="value">{{calculatorValue?.toLocaleString()}} {{settings?.currency}}</div>
            </div>
            <button v-if="miniCollapsed" class="more" @click.prevent="miniCollapsed = !miniCollapsed">{{settings?.local?.readMore}}</button>
            <button v-if="!miniCollapsed" class="submit mainButton" @click.prevent="miniCollapsed = !miniCollapsed">{{settings?.local?.save}}</button>
        </div>

        <div class="holder" v-else>
            <div class="mainTitle">{{settings?.local?.lemonza.pickSum}}</div>
            <vue-slider
                v-model="calculatorValue"
                v-bind="options"
                @change="handeDrag"
                @dragging="handeDrag"
            />
            <div class="settingsLine">
                <div class="product" v-if="settings?.creditTypes">
                    <div class="title">{{settings?.local?.lemonza.financeProduct}}</div>
                    <div class="selectHolder">
                        <select v-model="productType" @change="saveToLocalStorage">
                            <option v-for="(label, key, index) in settings.creditTypes" :key="key" :value="key">{{label}}</option>
                        </select>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M360.5 217.5l-152 143.1C203.9 365.8 197.9 368 192 368s-11.88-2.188-16.5-6.562L23.5 217.5C13.87 208.3 13.47 193.1 22.56 183.5C31.69 173.8 46.94 173.5 56.5 182.6L192 310.9l135.5-128.4c9.562-9.094 24.75-8.75 33.94 .9375C370.5 193.1 370.1 208.3 360.5 217.5z"></path></svg>

                    </div>
                </div>
                <button v-if="settings.local" data-target="target_goal_get_money" :data-href="settings?.url" type="button" class="submit comeback" @click="saveToLocalStorage">
                    {{settings?.local.lemonza.getMoney}}
                </button>
                <div class="total" v-if="calculatorValue && isLemonza">
                    <div class="yuoGet"><span>{{calculatorValue.toLocaleString()}} {{settings?.currency}}</span> {{settings?.local?.lemonza.youGet}}</div>
                    <div class="probability"><span>{{probabilityCalc()}}%</span> {{settings?.local?.lemonza.probability}}</div>
                </div>

                <div class="total" v-if="calculatorValue && isZaimoo">
                    <div class="yuoGet">
                        {{settings?.local?.lemonza.youGet}}: <span>{{calculatorValue.toLocaleString()}} {{settings?.currency}}</span>
                    </div>
                    <div class="probability">
                        {{settings?.local?.lemonza.probabilityZaimoo}}: <span>{{probabilityCalc()}}%</span>
                    </div>
                </div>
            </div>
            <div v-if="footerText" class="footerText">
                {{footerText}}
            </div>
        </div>

    </div>

</template>

<script setup>
import  VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import '@/assets/css/form.css';
import {onMounted, ref} from "vue";
import {ajax, setCookie, data, hasClass} from "@/assets/js/Functions";


const props = defineProps({
    element: Object
});

const settings = ref({})
let options = {}

const productType = ref(1)
const calculatorValue = ref(0)

const mini = ref(data(props.element,'mini')) ?? false
const miniCollapsed = ref(true)

const footerText = ref(data(props.element,'footerText')) ?? false
const isLemonza = ref(hasClass(props.element, 'CreditCalculatorLemonza')) ?? false
const isZaimoo = ref(hasClass(props.element, 'CreditCalculatorZaimoo')) ?? false

const formattedSum = () => {
    return (parseInt(calculatorValue.value * 1.06)).toLocaleString()
}

const formatValue = (value, addCurrency = true, float = false) => {
    return (float ? value : parseInt(value)).toLocaleString() + (addCurrency && settings?.value?.currency ? ' ' + settings.value.currency : '')
}

const probabilityCalc = () => {
    let maxPercent = 99;
    let percentStep = parseInt((settings?.value.max - settings?.value.min) / 38);
    return maxPercent - Math.round((calculatorValue?.value - settings?.value.min) / percentStep)
}

const handeDrag = (value) => {
    const firstLabel = document.querySelector('.vue-slider-marks .vue-slider-mark:first-child');
    const lastLabel = document.querySelector('.vue-slider-marks .vue-slider-mark:last-child');
    if(firstLabel) firstLabel.style.visibility = (value <= settings.value.min + 0.15 * (settings.value.max - settings.value.min)
        ? 'hidden' : 'visible')

    if(lastLabel) lastLabel.style.visibility = (value >= settings.value.max - 0.15 * (settings.value.max - settings.value.min)
        ? 'hidden' : 'visible')

    calculatorValue.value = value
    saveToLocalStorage()
}

// Инициализация значений из localStorage при создании компонента
onMounted(() => {
    const storedProductType = localStorage.getItem('productType');
    if (storedProductType) {
        productType.value = JSON.parse(storedProductType);
    }

    const storedCalculatorValue = localStorage.getItem('calculatorValue');
    if (storedCalculatorValue) {
        calculatorValue.value = parseFloat(storedCalculatorValue);
    }
    ajax({
        action: "get_calculator_settings",
    }, (response) => {
        settings.value = response
        calculatorValue.value = localStorage.getItem('calculatorValue') ? parseInt(localStorage.getItem('calculatorValue')) : response.from
        options = {
            silent: true,
            dotSize: 30,
            width: 'auto',
            height: 6,
            duration: 0,
            disabled: false,
            marks: [
                response.min,
                response.max
            ],
            min: response.min,
            max: response.max,
            interval: Number.isInteger((response.max - response.min) / response.step) ? response.step : 1,
            enableCross: true,
            hideCoveredLabels: true,
            tooltip: 'always',
            tooltipFormatter: value => formatValue(value, true),
            dotOptions: {
                disabled: false,
                style: {
                    border: '5px solid var(--color-primary)',
                    boxShadow: 'none'
                }
            },
        }
    });
});

// Сохранение значений в localStorage при изменении переменных
const saveToLocalStorage = () => {
    setCookie('summ', calculatorValue.value, '365')
    localStorage.setItem('productType', JSON.stringify(productType.value));
    localStorage.setItem('calculatorValue', calculatorValue.value);
};

</script>

<style>
.calculator.lz {
    width: 100%;
    max-width: 100%;
    margin: auto;
    font-family: inherit;
    padding: 30px 55px 25px;
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    border-style: solid;
    border-width: 3px;
    border-radius: 10px;
    box-shadow: 0 3px 10px 0 rgb(0 0 0 / 10%);
    box-sizing: border-box;
}
.calculator.lz :not(.mini) .vue-slider-ltr .vue-slider-mark-label, .calculator.lz :not(.mini) .vue-slider-rtl .vue-slider-mark-label {
    top: -30px;
    margin-top: 0;
    color: #333;
    font-size: 14px;
    line-height: 1;
    padding: 3px 5px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 4px;
    font-weight: 400;
}
.calculator.lz .mainTitle{
    display: block;
    text-align: center;
    font-size: 24px;
    line-height: 1.2;
    letter-spacing: 0.04em;
    margin-bottom: 50px;
}
.calculator.lz .vue-slider-dot-tooltip-inner{
    font-size: 14px;
    line-height: 1;
    text-shadow: none;
    padding: 3px 5px;
    background-color: var(--color-primary);
    border-color: var(--color-primary);
}
.calculator.lz .settingsLine {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: flex-end;
    justify-content: center;
    margin-top: 20px;
}
.calculator.lz .settingsLine > div, .calculator.lz .settingsLine > button{
    flex: 1 1 0;
}
.calculator.lz button.submit{
    margin: 0;
    font-size: 18px;
    font-weight: 500;
    background: var(--color-primary);
    transition: background-color 300ms ease-in-out;
}
.calculator.lz button.submit:hover{
    background: var(--color-primary-hover);
}
.calculator.lz .settingsLine .title{
    font-weight: normal;
    opacity: 0.8;
    margin-bottom: 5px;
    font-size: 12px;
    word-wrap: break-word;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}
.calculator.lz .settingsLine .selectHolder{
    position: relative;
    padding-bottom: 0;
}
.calculator.lz .settingsLine select{
    background: #e8e8e8;
    border-radius: 5px;
    padding: 16px 41px 16px 11px;
    border: none;
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    cursor: pointer;
    font-size: 16px;
}
.calculator.lz .settingsLine .product svg {
    position: absolute;
    right: 20px;
    width: 20px;
    height: 20px;
    top: calc(50% - 10px);
}
.calculator.lz .total{
    line-height: 1;
    font-size: 16px;
    font-weight: 400;
}
.calculator.lz .total span {
    font-size: 22px;
    line-height: 1.6;
    letter-spacing: 0;
}
.calculator.lz .total .probability span {
    letter-spacing: 0;
    color: var(--color-primary);
}
.CreditCalculatorLemonza.compact .settingsLine{
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.CreditCalculatorLemonza.compact .settingsLine > div, .calculator .settingsLine > button {
    width: 100%;
}
.CreditCalculatorLemonza.compact .calculator {
    padding: 25px;
}
.CreditCalculatorLemonza.compact .total {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.calculator.lz .footerText {
    text-align: center;
    margin: 20px 0 0 0;
}
.CreditCalculatorZaimoo .settingsLine{
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.CreditCalculatorZaimoo .settingsLine > div, .CreditCalculatorZaimoo .settingsLine > button {
    width: 100%;
}
.CreditCalculatorZaimoo .settingsLine .product{
    order: 1;
}
.CreditCalculatorZaimoo .settingsLine .total{
    order: 2;
}
.CreditCalculatorZaimoo .settingsLine button{
    order: 3;
}
.CreditCalculatorZaimoo .total {
    color: #1a1a1a;
    font-size: 18px;
}
.CreditCalculatorZaimoo .calculator .total span{
    line-height: 1.6;
    letter-spacing: 0;
    font-size: 20px;
    font-weight: 600;
    color: var(--color-primary);
}
@media (max-width: 1199px){
}
@media (max-width: 767px){
    .calculator.lz .settingsLine {
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    .calculator.lz .settingsLine > div, .calculator .settingsLine > button {
        width: 100%;
    }
    .calculator.lz {
        padding: 25px;
    }
}
@media(max-width: 500px) {
    .calculator.lz .mainTitle {
        font-size: 18px;
    }
}
</style>